import { AxiosRequestAdapter as AxiosRequestAdapter_ } from './axios-adapter';
export * from './abortable-call';
export * from './request-cache';

export const AxiosRequestAdapter = AxiosRequestAdapter_;
export const AxiosRequest = new AxiosRequestAdapter_();
